import { ProductInfoItem } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { ProductListItem } from '@components';
import { Box } from '@mui/material';
import { t } from '@translations';
import { isValidEmail } from '@utils/forms.utils';
import dayjs from 'dayjs';

type ProductInfoRequestListRowProps = {
  productInfoRequest: ProductInfoItem;
  isBeremaUser?: boolean;
};

export const productInfoRequestItems = ({
  isBeremaUser,
  productInfoRequest,
}: ProductInfoRequestListRowProps) => [
  {
    fieldName: 'requestDate',
    component: (
      <Box display='flex' alignItems='center' height='100%'>
        {dayjs(productInfoRequest.timestamp, { utc: true }).format('DD.MM.YYYY HH:mm')}
      </Box>
    ),
  },
  ...(isBeremaUser
    ? [
        {
          fieldName: 'dealerName',
          component: (
            <Box display='flex' alignItems='center' height='100%'>
              {productInfoRequest.dealer.name}
            </Box>
          ),
        },
      ]
    : []),
  {
    fieldName: 'createdBy',
    component: <CreatedBy productInfoRequest={productInfoRequest} />,
  },
  { fieldName: 'product', component: <ProductListItem {...productInfoRequest.product} /> },
  {
    fieldName: 'question',
    component: (
      <Box display='flex' alignItems='center' height='100%'>
        {productInfoRequest.question}
      </Box>
    ),
  },
  {
    fieldName: 'status',
    component: (
      <Box display='flex' alignItems='center' height='100%'>
        {productInfoRequest.status
          ? t(TextCodes.ProductRequest.Status[productInfoRequest.status])
          : ''}
      </Box>
    ),
  },
];

export const productInfoRequestListColumns = (isBeremaUser?: boolean) => [
  { key: 'requestDate', name: t(TextCodes.ProductRequest.Base.RequestDate) },
  ...(isBeremaUser
    ? [{ key: 'dealerName', name: t(TextCodes.ProductRequest.Base.DealerName) }]
    : []),
  { key: 'createdBy', name: t(TextCodes.ProductRequest.Base.CreatedBy) },
  { key: 'product', name: t(TextCodes.ProductRequest.Base.Product) },
  { key: 'question', name: t(TextCodes.ProductRequest.Info.Question) },
  { key: 'status', name: t(TextCodes.ProductRequest.Base.Status) },
];

const CreatedBy = ({ productInfoRequest }: { productInfoRequest: ProductInfoItem }) => {
  return (
    <Box display='flex' alignItems='center' height='100%'>
      {isValidEmail(productInfoRequest.contact.fullName) ? (
        <div
          onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = 'mailto:' + productInfoRequest.contact.fullName;
          }}
          className='link primary'
        >
          {productInfoRequest.contact.fullName}
        </div>
      ) : (
        <div>{productInfoRequest.contact.fullName}</div>
      )}
    </Box>
  );
};
